import React, { useEffect, useReducer, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { subscribe } from "../utils/pubsub"
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'
import Spinner from '../ui-elements/Spinner'
import DeleteButton from '../formfields/DeleteButton'
import { validateForm } from '../utils/validateForm'
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import JsonDebug from '../ui-elements/JsonDebug'


type Props = {
}

function ListUsers({
}: Props) {



  const {
    tableData,
    userData,
    fridges,
    currentOrganisation,
    switchCurrentOrganisation,
    sendMessageToWebsocket,
    checklistSetupFields,
    setChecklistSetupFields,
    checklistQuestionFields,
    setChecklistQuestionFields,
    activeFeatures,
    expiredFeatures,
    loggedIn,
    loginUrl,
    setShowModal,
    currentPortalId
  } = useContext(GlobalContext)

  const initialFormData = {
    "email": { "value": '', "required": true, "type": "email" }
  }
  const [addOrEditItem, setAddOrEditItem] = useState<string | null>(null)
  const [showAddUserModal, setShowAddUserModal] = useState(false)
  const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>(initialFormData)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  // console.log(formFields)




  const addUser = async () => {

    let emailRegex = new RegExp("^.+@.+")
    if (
      !formFields['email']
      || !formFields['email']['value']
      || emailRegex.test(formFields['email']['value']) === false
    ) {
      console.log("invalid email")
      const newFieldValues = { ...formFields }
      newFieldValues['email'] = { ...newFieldValues['email'], 'isValid': false }
      setFormFields(newFieldValues)
    } else {

      console.log("valid email")
      const newFieldValues = { ...formFields }
      delete newFieldValues['email']
      setFormFields(newFieldValues)
      setShowModal({ "spinner": "Inviting user..." })
      setShowAddUserModal(false)
      const newRowId = crypto.randomUUID()

      const payload = JSON.stringify({
        action: "user",
        subAction: "addToPortal",
        email: `${formFields['email'].value}`,
        rowId: newRowId,
        portalId: currentPortalId
      })

      const unsubscribe = subscribe("addUserResponse", data => {
        if (data && data.rowId && data.rowId === newRowId) {
          setShowModal(null)
        }
        unsubscribe()
      })

      sendMessageToWebsocket(payload)
    }
  }

  const deleteUser = async (functionParams: ObjectStringKeyAnyValue) => {
    const { rowId, userId, email } = functionParams
    console.log("delete user", rowId, userId, email)
    if (userId && email) {
      setShowModal({ "spinner": "Deleting user..." })
      setShowAddUserModal(false)

      const payload = JSON.stringify({
        action: "user",
        subAction: "deleteFromPortal",
        rowId: rowId,
        userId: userId,
        email: email,
        portalId: currentPortalId
      })

      const unsubscribe = subscribe("deleteUserResponse", data => {
        if (data && data.rowId && data.rowId === rowId) {
          setShowModal(null)
        }
        unsubscribe()
      })
      sendMessageToWebsocket(payload)
    }
  }



  const handleChange = (key: string, value: any) => {
    const newFieldValues: ObjectStringKeyAnyValue = { ...formFields }
    newFieldValues[key] = { ...newFieldValues[key], 'value': value }
    setFormFields(newFieldValues)
  }


  if (!userData || !tableData || !tableData.PortalUsers) {
    return <div className={`w-full flex flex-col items-center`}>
      <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 `}>
        <div className={`flex flex-row justify-between gap-4`}>
          <h2 className={`text-3xl  font-bold font-righteous text-brandblue`}
          >
            Users
          </h2>
        </div>
        <Spinner>Loading...</Spinner>
      </div>
    </div>
  }



  return <div className={`w-full flex flex-col items-center`}>
    <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 `}>


      <div className={`w-full flex flex-row justify-between gap-4`}>
        <h2 className={`text-3xl  font-bold font-righteous text-brandblue`}
        >
          Portal Users
        </h2>



        <Button
          onClick={() => setShowAddUserModal(true)}
          text={'Invite new user'}
          variant={'primary'}
          fullwidth={false}
        />

      </div>


      {showAddUserModal &&
        <Modal>
          <h2 className={`text-xl font-bold text-brandblue  mb-4`}>
            Invite a new user
          </h2>

          <div className={`flex flex-col gap-4 border-none`}>
            <input
              className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              type='text'
              placeholder={'email address'}
              value={formFields['email'] ? formFields['email']['value'] : ''}
              onChange={(e) => handleChange('email', e.target.value.toLowerCase())}
            />

            {formFields['email'] && formFields['email']['isValid'] === false && <p className={`text-xs text-red-700`}>Please enter a valid email address</p>}

            <div className={`flex flex-row gap-4 justify-between`}>


              <Button
                onClick={() => {
                  setShowAddUserModal(false)
                  setFormFields(initialFormData)
                }}
                text={'Cancel'}
                variant={'gray'}
              />

              <Button
                onClick={addUser}
                text={'Invite'}
                variant={'primary'}
              />



            </div>
          </div>
        </Modal>
      }



      <div>
        {errorMessage && <RedAlert >{errorMessage}</RedAlert>}
        <h4 className={`text-xl font-bold text-brandblue `}>{Object.keys(tableData.PortalUsers).length} users found</h4>

        <div className={`pt-3 flex flex-col w-full gap-2`}>
          {Object.keys(tableData.PortalUsers).map((userId: any, index: number) => {
            const user = tableData.PortalUsers[userId] 


            return <div key={index} className={`p-2 bg-white border ${user.UserId === userData!['cognito:username'] ? 'border-gray-400' : 'border-gray-200'} rounded hover:opacity-90-lg shadow flex flex-row gap-4 items-center justify-between`}>
              
              
              {(user.UserEmail || user.UserName) ? <div>
                {user.UserName && <p className={`text-sm font-bold text-black`}>{user.UserName}</p>}
                {user.UserEmail && <p className={`text-sm text-black`}>{user.UserEmail}</p>}
              </div> :
              
              <div>
                <p className={`text-sm font-bold text-black`}>User Id: #{user.UserId}</p>
              </div>
              }
              


              {user.UserId !== userData!['cognito:username'] && <div className={`flex flex-row gap-2 items-center`}>

                <DeleteButton
                  deleteFunction={deleteUser}
                  fullwidth={false}
                  functionParams={{
                    rowId: user.Id,
                    email: user.UserEmail,
                    userId: user.UserId
                  }}
                />
              </div>}

            </div>
          })}
        </div>
      </div>


      {/* <JsonDebug jsonobject={tableData.PortalUsers} /> */}


    </div>
  </div>
}
export default ListUsers